import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Input, Form, Card, CardHeader, CardBody } from '@heroui/react';
import authService from '../../services/auth.service';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setIsLoading(true);

    try {
      await authService.forgotPassword(email);
      setMessage('Password reset link has been sent to your email.');
      setEmail('');
    } catch (err) {
      setError(err?.message || 'Failed to send reset link. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div 
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100 px-4"
      style={{ fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' }}
    >
      <Card className="max-w-md w-full" style={{ padding: '48px' }}>
        <CardHeader className="flex flex-col gap-3 px-0 pt-0 pb-6">
          <div className="flex justify-center w-full mb-2">
            <img 
              src="/taasa-logo.png" 
              alt="Taasa Logo" 
              className="h-20 w-auto"
            />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 text-center">Forgot Password</h1>
          <p className="text-gray-600 text-center">Enter your email and we'll send you a reset link</p>
        </CardHeader>
        
        <CardBody className="px-0 py-0">
          <Form onSubmit={handleSubmit} className="flex flex-col gap-4">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
                {error}
              </div>
            )}

            {message && (
              <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded">
                {message}
              </div>
            )}

            <Input
              type="email"
              label="Email"
              labelPlacement="outside"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              isRequired
              size="lg"
            />

            <Button
              type="submit"
              color="primary"
              size="lg"
              className="w-full"
              isLoading={isLoading}
              disabled={isLoading}
            >
              Send Reset Link
            </Button>

            <div className="text-center text-sm text-gray-600">
              Remember your password?{' '}
              <Link to="/login" className="text-blue-600 hover:text-blue-700 font-medium">
                Sign in
              </Link>
            </div>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
};

export default ForgotPassword;